import { useTranslation } from "react-i18next";

import { currentTrialToken } from "@/lib/storefrontTrial";

/**
 * Pruh po celou dobu zkušebního nákupu (KAN-761).
 *
 * Objednávka z pozvánky vznikne jako testovací a do tržeb, provizí ani
 * statistik nevstoupí. To je správně — a tenant to musí vědět **předtím**,
 * než ji zaplatí. Bez pruhu by udělal nákup a pak hledal, proč v číslech
 * není; s pruhem je to očekávaný výsledek.
 *
 * Sedí v shellu, ne na pokladně: cesta má čtyři zastávky (překlopení
 * souboru → cena → košík → pokladna) a pozvánka platí na všech.
 */
export function StorefrontTrialBanner(): JSX.Element | null {
  const { t } = useTranslation("admin");

  if (currentTrialToken() === null) return null;

  return (
    <div
      className="border-b border-border bg-surface-2"
      data-testid="storefront-trial-banner"
      role="status"
    >
      <div className="mx-auto flex w-full max-w-[1440px] flex-wrap items-center gap-3 px-4 py-2 sm:px-6 lg:px-8">
        <span className="mono inline-flex items-center rounded bg-ink px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wider text-bg">
          {t("storefrontTrial.tag")}
        </span>
        <p className="min-w-0 flex-1 text-sm text-ink-2">
          {t("storefrontTrial.bannerLead")}
        </p>
      </div>
    </div>
  );
}
